package app.bloomey.web.core.res

object Res {
    object Strings

    object Assets
    object Destinations

    object Dimens

}